import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01125432"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weeek-settings-token__block" }

import { TirPmButton, TirPmButtonVariantEnum, TirPmInput } from "tir-components";
import { computed, onBeforeMount, onMounted, onUnmounted, ref, watch } from "vue";
import { AdapterService } from "../adapter";
import { WeeekOptionsUpdateApiKeyRequest } from "../models";
import { CheckIcon } from "tir-style-system/icons/outline";

/**Адаптер */

export default /*#__PURE__*/_defineComponent({
  __name: 'weeek-settings-token',
  props: {
  /**ID проекта */
  projectId: { type: Number },
  /**ApiKey */
  apiKey: { type: String },
},
  emits: ["updateApiKey", "updateProjectSettings"],
  setup(__props, { emit }) {

const props = __props;

const adapter = new AdapterService();

/**Параметры */

/**События */


/**Загрузка */
const isLoading = ref(false);
/**Удачное обновление апи ключа */
const isSucceessUpdateApiKey = ref();
/**Данные инпута */
const inputData = ref("");

/**Отличается ли текущая данная инпута с прошлой */
const isInputChanged = computed(() => props.apiKey == inputData.value || inputData.value == "");

/**При обновлении apiKey */
watch(() => props.apiKey, setInputData, { immediate: true });

/**Изменение данных инпута */
function setInputData() {
  inputData.value = props.apiKey;
}
/**Обновить ключ апи */
const updateKeyApi = async () => {
  isLoading.value = true;
  const response = await adapter.updateApiKeyAsync(
    new WeeekOptionsUpdateApiKeyRequest({
      ProjectId: props.projectId,
      ApiKey: inputData.value,
    }),
  );
  if (response.IsSuccess) {
    isSucceessUpdateApiKey.value = true;
    emit("updateApiKey", inputData.value);
    emit("updateProjectSettings");
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TirPmInput), {
        class: "weeek-settings-token__input",
        label: "Ключ для авторизации токена",
        modelValue: inputData.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData).value = $event)),
        isWithHint: false
      }, _createSlots({ _: 2 }, [
        (isSucceessUpdateApiKey.value)
          ? {
              name: "rightInputAddons",
              fn: _withCtx(() => [
                _createVNode(_unref(CheckIcon), { class: "weeek-settings-token__icon" })
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"]),
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        isDisabled: isInputChanged.value,
        isLoading: isLoading.value,
        onClick: updateKeyApi
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Сохранить ")
        ]),
        _: 1
      }, 8, ["variant", "isDisabled", "isLoading"])
    ])
  ]))
}
}

})